import { render, staticRenderFns } from "./socialBenefits.vue?vue&type=template&id=51607842&scoped=true"
import script from "./socialBenefits.vue?vue&type=script&lang=js"
export * from "./socialBenefits.vue?vue&type=script&lang=js"
import style0 from "./socialBenefits.vue?vue&type=style&index=0&id=51607842&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51607842",
  null
  
)

export default component.exports